// extracted by mini-css-extract-plugin
export default {"small":"style_small__Fpnym","large":"style_large__S7TK5","tiny":"style_tiny__TJxb-"};